import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Home, Menu, X } from "lucide-react";
import { useState } from "react";

const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const Navbar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/directory", label: "Directory", id: "nav-directory-link" },
    { to: "/pricing", label: "Pricing", id: "nav-pricing-link" },
    { to: "/how-it-works", label: "How It Works", id: "nav-how-link" },
    { to: "/blog", label: "Blog", id: "nav-blog-link" },
  ];

  return (
    <header className="glass-nav sticky top-0 z-50">
      <nav className="container-x h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-9 h-9 rounded-lg btn-primary grid place-items-center">
            <Home className="w-5 h-5 text-white" />
          </span>
          <span className="font-display font-extrabold text-xl tracking-tight text-[color:var(--navy)]">
            InspectorPro<span className="text-[color:var(--emerald)]">Leads</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={l.id}
              className={`text-sm font-medium transition-colors hover:text-[color:var(--emerald)] ${loc.pathname === l.to ? "text-[color:var(--emerald)]" : "text-[color:var(--ink-2)]"}`}>
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Button onClick={() => nav("/quote")} data-testid="nav-request-quote-button"
            className="btn-amber rounded-full px-5 font-semibold">Request a Quote</Button>
          {user ? (
            <div className="flex items-center gap-3">
              <Button variant="ghost" onClick={() => nav(user.role === "admin" ? "/admin" : "/dashboard")}
                data-testid="nav-dashboard-link" className="rounded-full font-medium">
                {user.role === "admin" ? "Admin" : "Dashboard"}
              </Button>
              <button onClick={logout} data-testid="nav-logout-button" className="text-sm text-[color:var(--ink-3)] hover:text-[color:var(--ink)]">Log out</button>
            </div>
          ) : (
            <Button onClick={startGoogleLogin} variant="outline" data-testid="nav-login-button"
              className="rounded-full border-slate-300 font-semibold">For Pros — Log in</Button>
          )}
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden container-x pb-5 flex flex-col gap-3 bg-white/95">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-2 font-medium text-[color:var(--ink-2)]">{l.label}</Link>
          ))}
          <Button onClick={() => { setOpen(false); nav("/quote"); }} className="btn-amber rounded-full">Request a Quote</Button>
          {user ? (
            <>
              <Button variant="outline" onClick={() => { setOpen(false); nav(user.role === "admin" ? "/admin" : "/dashboard"); }} className="rounded-full">{user.role === "admin" ? "Admin" : "Dashboard"}</Button>
              <button onClick={logout} className="text-sm text-[color:var(--ink-3)]">Log out</button>
            </>
          ) : (
            <Button onClick={startGoogleLogin} variant="outline" className="rounded-full">For Pros — Log in</Button>
          )}
        </div>
      )}
    </header>
  );
};

export { startGoogleLogin };
